import { useQueryGetProducts } from 'state/internal/getProducts';

export function useTitleForInStockProduct(variantId: number | string) {
  const allProducts = useQueryGetProducts().data?.items;
  const variant = allProducts?.find((product) =>
    product.variants.find((productVariant) => productVariant.id === variantId)
  );
  return variant?.title;
}
